import { render, staticRenderFns } from "./request-detail.vue?vue&type=template&id=0a408958&scoped=true&"
import script from "./request-detail.vue?vue&type=script&lang=js&"
export * from "./request-detail.vue?vue&type=script&lang=js&"
import style0 from "./request-detail.vue?vue&type=style&index=0&id=0a408958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a408958",
  null
  
)

export default component.exports